<template lang="pug">
div
  .row
    .columns.large-24.organization-item(:data-href="url")
        .picture
           img(:src="getImg(org.logo, 'v_90_90')", alt="logo")
        .name
            a(:href="get_locale() + url") {{org.name}}
            .tagline
                | {{org.tag_line}}
            .location(v-if="org.main_address")
                | {{general_location}}
        .description(v-html="descr" , v-linkified="")
  .row
    .columns.large-24(:data-href="url")
        .description
  .row.organization-programs(v-if="search_programs.length > 0 || (loading && org._index==='organizations')")
      .row(v-if="loading")
          | Loading...
      .row(v-else v-for="program in search_programs")
          .columns.large-20.large-offset-3
            table.organization-programs(:data-href="`/programs/${program.slug}`")
                thead
                    tr
                        th {{t('app.programs.search.program')}}
                        th {{t('app.programs.search.dates')}}
                        th {{t('app.programs.search.price')}}
                        th {{t('app.programs.search.registration')}}
                tbody
                    tr.program-section
                        td.program-name
                            router-link(:to="`${get_locale()}/programs/${program.slug}`") {{program.name}}
                        td
                            span(v-if="program.min_starts_at")
                                | {{I18n.toTime('date.formats.short',program.min_starts_at.split("T")[0])}}
                                span(v-if="program.max_ends_at")
                                    | - {{I18n.toTime('date.formats.short',program.max_ends_at.split("T")[0])}}
                        td
                            | {{I18n.toCurrency(program.min_price,{strip_insignificant_zeros: true})}}
                            span(v-if="program.min_price !== program.max_price")
                                | - {{I18n.toCurrency(program.max_price,{strip_insignificant_zeros: true})}}
                        td.status
                            span(:class="[openClass(program)]")
                                span(
                                    v-if="program.render_registration_state==='pending'"
                                    v-html="t('app.programs.registration_date_pending',{date: I18n.toTime('date.formats.numeric',program.registration_starts_at.split('T')[0])})"
                                )
                                span(
                                    v-else
                                    v-text="t(`app.programs.registration_${program.render_registration_state}`)"
                                )
</template>
<script>
import WithRequired from '../registrations/shared/_with_required'
const descr_length = 301
export default {
  props: ['org'],
  components: {WithRequired},
  data(){
    return {
      search_programs: [],
      loading: true,
      I18n,
    }
  },
  async mounted(){
    if (this.org._index==='organizations' && (this.$route.query.query||this.$route.query.query_state)){
      const resp = await this.axios.get('/api2/family/programs', {params: {organization_id: this.org.id, include: ['search_data'], order: "state_sorted"}})
      this.search_programs = resp.data.object
    }

    this.loading=false
    FamilyID.Views.Href.init() // hack for now
  },
  computed: {
    general_location(){
      let arr = []
      if (this.isPresent(this.org.main_address.city))  arr.push(this.org.main_address.city)
      if (this.isPresent(this.org.main_address.state)) arr.push(this.org.main_address.state)
      return arr.join(", ")
    },
    url(){
      if (this.org._index === 'accounts'){
        return `/enterprise/${this.org.slug||this.org.id}`
      }
      return `/${this.org._index}/${this.org.slug||this.org.id}`
    },
    descr(){
      if (!this.org.description) {
        return "";
      }else if (this.org.description.length > descr_length){
        const text = this.org.description.substring(0, descr_length)
        return this.$sanitize(text, {allowedTags: []}) + ` <a href="${this.url}">${this.t('app.buttons.read_more')}</a>`
      }else{
        return this.$sanitize(this.org.description, {allowedTags: []})
      }
    },
  },
  methods: {
    openClass(program){
      return ['open', 'full'].includes(program.render_registration_state) ? 'open' : 'closed'
    }
  }
}
</script>
